import { createElementVNode as _createElementVNode, vModelText as _vModelText, normalizeClass as _normalizeClass, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelSelect as _vModelSelect, withModifiers as _withModifiers, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "row mb-40" }
const _hoisted_2 = { class: "col-xxl-10 col-lg-8 pe-xxl-8" }
const _hoisted_3 = { class: "card border-0 rounded-1" }
const _hoisted_4 = { class: "row mb-3 align-items-center" }
const _hoisted_5 = { class: "col-8" }
const _hoisted_6 = {
  key: 0,
  class: "text-danger small"
}
const _hoisted_7 = { class: "row mb-3 align-items-center" }
const _hoisted_8 = { class: "col-8" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { class: "row mb-3 align-items-center" }
const _hoisted_11 = { class: "col-8" }
const _hoisted_12 = { class: "row mb-3 align-items-center" }
const _hoisted_13 = { class: "col-8" }
const _hoisted_14 = { class: "row mb-3 align-items-center" }
const _hoisted_15 = { class: "col-8" }
const _hoisted_16 = {
  key: 0,
  class: "text-danger small"
}
const _hoisted_17 = { class: "col-xxl-2 col-lg-4" }
const _hoisted_18 = { class: "card border-0 rounded-1 w-xxl-5 pt-12 pb-12 mb-md-25" }
const _hoisted_19 = { class: "table style-two" }
const _hoisted_20 = { class: "fs-14 fw-bold lh-1 text-purple text-end" }
const _hoisted_21 = { class: "fs-14 fw-semibold lh-1 text-optional text-end" }
const _hoisted_22 = { class: "fs-14 fw-semibold lh-1 text-optional text-end" }
const _hoisted_23 = { class: "fs-14 fw-bold lh-1 text-purple text-end" }
const _hoisted_24 = { class: "fs-14 fw-semibold lh-1 text-optional text-end" }
const _hoisted_25 = { class: "fs-14 fw-bold lh-1 text-purple text-end" }
const _hoisted_26 = { class: "col-xl-4" }
const _hoisted_27 = {
  key: 0,
  class: "modal fade show d-block",
  tabindex: "-1"
}
const _hoisted_28 = { class: "modal-dialog modal-dialog-centered" }
const _hoisted_29 = { class: "modal-content" }
const _hoisted_30 = { class: "modal-title" }
const _hoisted_31 = { class: "modal-body" }
const _hoisted_32 = { key: 0 }
const _hoisted_33 = { key: 1 }
const _hoisted_34 = { class: "modal-footer" }
const _hoisted_35 = {
  key: 1,
  class: "modal-backdrop fade show"
}
const _hoisted_36 = {
  key: 2,
  class: "modal-backdrop fade show"
}
const _hoisted_37 = {
  key: 3,
  class: "modal-backdrop fade show"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("form", {
            class: "p-4",
            onSubmit: _cache[7] || (_cache[7] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submitSales && $setup.submitSales(...args)), ["prevent"]))
          }, [
            _cache[17] || (_cache[17] = _createElementVNode("h6", { class: "fs-18 mb-35 text-title fw-semibold" }, " Payment Infos ", -1)),
            _createElementVNode("div", _hoisted_4, [
              _cache[11] || (_cache[11] = _createElementVNode("div", { class: "col-4" }, [
                _createElementVNode("label", {
                  for: "discount",
                  class: "form-label"
                }, "Discount")
              ], -1)),
              _createElementVNode("div", _hoisted_5, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.submitPurchaseResume.discount) = $event)),
                  class: _normalizeClass(["form-control", {'is-invalid': $setup.cashError}]),
                  id: "discount",
                  name: "discount",
                  onInput: _cache[1] || (_cache[1] = ($event: any) => ($setup.validatePositiveField('discount'))),
                  placeholder: "Enter discount"
                }, null, 34), [
                  [
                    _vModelText,
                    $setup.submitPurchaseResume.discount,
                    void 0,
                    { number: true }
                  ]
                ]),
                ($setup.cashError)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_6, "Discount cannot be negative."))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _cache[13] || (_cache[13] = _createElementVNode("div", { class: "col-4" }, [
                _createElementVNode("label", {
                  for: "methodOfPayment",
                  class: "form-label"
                }, "Method of Payment")
              ], -1)),
              _createElementVNode("div", _hoisted_8, [
                _withDirectives(_createElementVNode("select", {
                  class: "form-select",
                  id: "methodOfPayment",
                  name: "methodOfPayment",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.methodOfPayment) = $event))
                }, _cache[12] || (_cache[12] = [
                  _createElementVNode("option", { value: "Cash" }, "Cash", -1),
                  _createElementVNode("option", { value: "MonCash" }, "MonCash", -1),
                  _createElementVNode("option", { value: "NatCash" }, "NatCash", -1)
                ]), 512), [
                  [_vModelSelect, $setup.methodOfPayment]
                ])
              ])
            ]),
            ($setup.methodOfPayment === 'MonCash' || $setup.methodOfPayment === 'NatCash')
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  _createElementVNode("div", _hoisted_10, [
                    _cache[14] || (_cache[14] = _createElementVNode("div", { class: "col-4" }, [
                      _createElementVNode("label", {
                        for: "customerId",
                        class: "form-label"
                      }, "Customer ID")
                    ], -1)),
                    _createElementVNode("div", _hoisted_11, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.submitPurchaseResume.customerID) = $event)),
                        class: "form-control",
                        id: "customerId",
                        name: "customerId",
                        placeholder: "Enter Customer ID"
                      }, null, 512), [
                        [_vModelText, $setup.submitPurchaseResume.customerID]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_12, [
                    _cache[15] || (_cache[15] = _createElementVNode("div", { class: "col-4" }, [
                      _createElementVNode("label", {
                        for: "customerName",
                        class: "form-label"
                      }, "Customer Name")
                    ], -1)),
                    _createElementVNode("div", _hoisted_13, [
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.submitPurchaseResume.customerName) = $event)),
                        class: "form-control",
                        id: "customerName",
                        name: "customerName",
                        placeholder: "Enter Customer Name"
                      }, null, 512), [
                        [_vModelText, $setup.submitPurchaseResume.customerName]
                      ])
                    ])
                  ])
                ]))
              : _createCommentVNode("", true),
            _createElementVNode("div", _hoisted_14, [
              _cache[16] || (_cache[16] = _createElementVNode("div", { class: "col-4" }, [
                _createElementVNode("label", {
                  for: "amount",
                  class: "form-label"
                }, "Amount")
              ], -1)),
              _createElementVNode("div", _hoisted_15, [
                _withDirectives(_createElementVNode("input", {
                  type: "number",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.submitPurchaseResume.cash) = $event)),
                  class: _normalizeClass(["form-control", {'is-invalid': $setup.cashError}]),
                  id: "amount",
                  name: "amount",
                  onInput: _cache[6] || (_cache[6] = ($event: any) => ($setup.validatePositiveField('cash'))),
                  placeholder: "Enter amount"
                }, null, 34), [
                  [
                    _vModelText,
                    $setup.submitPurchaseResume.cash,
                    void 0,
                    { number: true }
                  ]
                ]),
                ($setup.cashError)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_16, "Cash amount cannot be negative."))
                  : _createCommentVNode("", true)
              ])
            ])
          ], 32)
        ])
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("div", _hoisted_18, [
          _cache[24] || (_cache[24] = _createElementVNode("h6", { class: "fs-18 mb-35 text-title fw-semibold p-4 pb-0" }, " Payment summary ", -1)),
          _createElementVNode("table", _hoisted_19, [
            _createElementVNode("tbody", null, [
              _createElementVNode("tr", null, [
                _cache[18] || (_cache[18] = _createElementVNode("th", {
                  scope: "row",
                  class: "fs-14 text-title lh-1 ls-1 fw-normal"
                }, "TOTAL :", -1)),
                _createElementVNode("td", _hoisted_20, " HTG " + _toDisplayString($setup.total.toFixed(2)), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[19] || (_cache[19] = _createElementVNode("th", {
                  scope: "row",
                  class: "fs-14 text-title lh-1 ls-1 fw-normal"
                }, "DISCOUNT :", -1)),
                _createElementVNode("td", _hoisted_21, " HTG " + _toDisplayString($setup.submitPurchaseResume.discount), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[20] || (_cache[20] = _createElementVNode("th", {
                  scope: "row",
                  class: "fs-14 text-title lh-1 ls-1 fw-normal"
                }, "SHIPPING :", -1)),
                _createElementVNode("td", _hoisted_22, " HTG " + _toDisplayString($setup.submitPurchaseResume.shippingCost), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[21] || (_cache[21] = _createElementVNode("th", {
                  scope: "row",
                  class: "fs-14 text-title lh-1 ls-1 fw-normal"
                }, "GRAND TOTAL :", -1)),
                _createElementVNode("td", _hoisted_23, " HTG " + _toDisplayString($setup.grandTotal.toFixed(2)), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[22] || (_cache[22] = _createElementVNode("th", {
                  scope: "row",
                  class: "fs-14 text-title lh-1 ls-1 fw-normal"
                }, "Cash :", -1)),
                _createElementVNode("td", _hoisted_24, " HTG " + _toDisplayString($setup.cash), 1)
              ]),
              _createElementVNode("tr", null, [
                _cache[23] || (_cache[23] = _createElementVNode("th", {
                  scope: "row",
                  class: "fs-14 text-title lh-1 ls-1 fw-normal"
                }, "RETURN :", -1)),
                _createElementVNode("td", _hoisted_25, " HTG " + _toDisplayString($setup.returnAmount.toFixed(2)), 1)
              ])
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_26, [
        ($setup.returnAmount >= 0)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              onClick: _cache[8] || (_cache[8] = _withModifiers(
//@ts-ignore
(...args) => ($setup.submitSales && $setup.submitSales(...args)), ["prevent"])),
              class: "btn style-one d-inline-block transition border-0 fw-medium text-white rounded-1 fs-md-15 fs-lg-16 mb-20"
            }, " Submit Sales "))
          : _createCommentVNode("", true)
      ])
    ]),
    ($setup.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
          _createElementVNode("div", _hoisted_28, [
            _createElementVNode("div", _hoisted_29, [
              _createElementVNode("div", {
                class: _normalizeClass(["modal-header", $setup.modalStatus === 'success' ? 'bg-success text-white' : 'bg-danger text-white'])
              }, [
                _createElementVNode("h5", _hoisted_30, _toDisplayString($setup.modalStatus === 'success' ? 'Success' : 'Error'), 1),
                _createElementVNode("button", {
                  type: "button",
                  class: "btn-close",
                  onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => ($setup.closeModal && $setup.closeModal(...args)))
                })
              ], 2),
              _createElementVNode("div", _hoisted_31, [
                ($setup.modalStatus === 'success')
                  ? (_openBlock(), _createElementBlock("p", _hoisted_32, [
                      _cache[25] || (_cache[25] = _createTextVNode(" Sales submitted successfully! Redirecting in ")),
                      _createElementVNode("strong", null, _toDisplayString($setup.countdown), 1),
                      _cache[26] || (_cache[26] = _createTextVNode(" seconds... "))
                    ]))
                  : (_openBlock(), _createElementBlock("p", _hoisted_33, "Failed to submit sales data. Please try again."))
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("button", {
                  type: "button",
                  class: "btn btn-primary",
                  onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => ($setup.redirectToSalesList && $setup.redirectToSalesList(...args)))
                }, " Go to Sales List Now ")
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true),
    ($setup.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_35))
      : _createCommentVNode("", true),
    ($setup.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_36))
      : _createCommentVNode("", true),
    ($setup.showModal)
      ? (_openBlock(), _createElementBlock("div", _hoisted_37))
      : _createCommentVNode("", true)
  ], 64))
}